import React, { useContext } from 'react'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import StepCounter from '../StepCounter'
import './style/Q1.css'
import one from './assets/one.png'
import two from './assets/two.png'
import gif1 from './assets/04_chat 2.gif'
import jpg1 from './assets/static/04_chat-2.jpg'
import three from './assets/three.png'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import '../Gif.css'
import Gif from '../../components/Gif'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';


const Q1 = () => {
    const { settings } = useContext(AppContext)
    const { translate } = useLocalize()
    const history = useHistory();
    return (
        <>
            <div className="picHold">
                <img className="gif1" src={settings.isAnimationPause ? jpg1 : gif1} />
            </div>
            <Headling text={translate('Getting to know you')} />
            <Subtitle text={translate('My status is')} />
            <div onClick={() => {
                setNewAnswer({ 1: 3 })
                history.push('/Q/2')
                ReactPixel.trackCustom('family', '');
            }}
                className="Q1option1">
                <img width="60px" src={three} alt="" />
                <div>{translate('Family')}</div>
            </div>


            <div onClick={() => {
                setNewAnswer({ 1: 2 })
                history.push('/Q/2')
                ReactPixel.trackCustom('couple', '');
            }} className="Q1option2">
                <img width="60px" src={two} alt="" />
                <div id="zug">{translate('Couple')}</div>
            </div>
            <div onClick={() => {
                setNewAnswer({ 1: 1 })
                history.push('/Q/2')
                ReactPixel.trackCustom('single', '');
            }} className="Q1option3">
                <img width="35px" src={one} alt="" />
                <div id="zug">{translate('Single')}</div>
            </div>
            <StepCounter />
        </>
    )
}



export default Q1

